export const __buttonWrapper = ({ theme, center, btnBg, fullWidth }) => ({
	cursor: 'pointer',
	borderRadius: theme.primary(theme).borderRadius,
	extend: [
		{
			condition: center,
			style: {
				display: 'flex',
				justifyContent: 'center',
			},
		},
		{
			condition: btnBg,
			style: {
				backgroundColor: theme.colors[`${btnBg}`],
			},
		},
		{
			condition: fullWidth,
			style: {
				width: '100%',
			},
		},
	],
})

export const __designLangBtn = ({
	theme,
	disabled,
	primary,
	secondary,
	smallBtn,
	mediumBtn,
	largeBtn,
	fullWidth,
}) => {
	return {
		textAlign: 'center',
		color: theme.colors.white,
		borderRadius: theme.primary(theme).borderRadius,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		extend: [
			{
				condition: primary,
				style: {
					backgroundColor: theme.primary(theme).backgroundColor,
					border: `1px solid ${theme.primary(theme).backgroundColor}`,
					color: theme.primary(theme).colorWhite,
				},
			},
			{
				condition: secondary,
				style: {
					backgroundColor: 'transparent',
					border: `1px solid ${theme.primary(theme).backgroundColor}`,
					color: theme.primary(theme).backgroundColor,
					flex: 'unset',
				},
			},
			{
				condition: smallBtn,
				style: {
					padding: '0',
					width: 72,
					flex: 'unset',
					fontSize: theme.font.size12,
					height: '24px',
				},
			},
			{
				condition: mediumBtn,
				style: {
					// ...padding(theme.spaces[12], theme.spaces[4]),
					width: 140,
					flex: 'unset',
					fontSize: theme.font.size14,
					height: '32px',
				},
			},
			{
				condition: largeBtn,
				style: {
					// ...padding(theme.spaces[16], theme.spaces[4]),
					width: 160,
					flex: 'unset',
					fontSize: theme.font.size16,
					height: '40px',
				},
			},
			{
				condition: fullWidth,
				style: {
					width: '100%',
					flexGrow: 1,
					fontSize: theme.font.size16,
					height: '40px',
				},
			},
			{
				condition: disabled,
				style: {
					opacity: '1',
					backgroundColor: theme.colors.lightGrey3,
					border: 'none',
					color: theme.colors.white,
				},
			},
		],
		onFocus: {
			outline: 'none',
		},
	}
}
